<template>
  <transition name="slide-fade">
    <v-container fluid @contextmenu="checkLock">
      <v-layout wrap class="noprint row justify-space-between px-5 screen-mx-10 mt-1">
        <span>
          <inertia-link v-if="visit" :href="'/clients/' + client.id + '/visits/' + visit.id + '/treatments'" as="button" class="v-btn">
            <v-icon small>mdi-arrow-left-bold-outline</v-icon> &nbsp;Treatments
          </inertia-link>
          <inertia-link v-if="pharmacy_request" :href="'/pharmacy_requests/' + pharmacy_request.id" as="button" class="v-btn">
            <v-icon small left>mdi-arrow-left-bold-outline</v-icon> &nbsp;Request
          </inertia-link>
          <v-btn small title="View Attached Request" @click="viewRequest = !viewRequest" icon color="error" v-if="request">
            <v-icon>mdi-map-marker-plus-outline</v-icon>
          </v-btn>
        </span>
        <div xs12>
          <h3 class="text-center mt-0">View Prescription</h3>
        </div>
        <span>
          <prescription-lock :treatment="treatment" :icon="!$breakpoint.mdAndUp"></prescription-lock>
          <v-btn small title="Add Dosage" @click="addDosage = !addDosage" outlined v-show="$breakpoint.mdAndUp">Add Dosage</v-btn>
          <inertia-link v-if="visit" as="button" class="v-btn" :href="'/clients/' + client.id + '/visits/' + visit.id + '/treatments/' + treatment.id + '/edit'">
            <v-icon small>mdi-pencil</v-icon>&nbsp; Edit
          </inertia-link>
          <invoices-button v-if="visit" :href="'/clients/' + client.id + '/visits/' + visit.id + '/treatments/' + treatment.id + '/invoices'" title="View Invoices" :disabled="!treatment.locked"></invoices-button>
          <invoices-button v-else :href="'/treatments/' + treatment.id + '/invoices'" title="View Invoices" :disabled="!treatment.locked"></invoices-button>
          <v-btn small title="Print" color="primary" @click="printPre" outlined  :disabled="!treatment.locked">
            <v-icon left>mdi-printer</v-icon>Print
          </v-btn>
        </span>
      </v-layout>
      <v-layout wrap class="justify-center">
        <v-flex xs12 md8 sm11>
          <v-card>
            <v-card-text>
              <prescription-view :client="client" :visit="visit" :treatment="treatment" :needed="true" @addDose="addDosage = true"></prescription-view>
            </v-card-text>
            <v-card-actions class="pa-0">
              <v-spacer></v-spacer>
              <span class="text-muted" v-if="!treatment.locked">This prescription is currently unlocked. You should lock it for dispatch and invoicing.</span>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <modal-dialog :open="addDosage" @close="addDosage = false">
        <template #title>Add Dosage</template>
        <v-card v-if="addDosage">
          <v-card-text>
            <form @submit.prevent="saveDosage">
              <v-autocomplete label="Select Drug" :items="drugs" item-text="name" item-value="id" v-model.number="dosage.drug_id" required hint="If you select a drug already in the prescription, only the details will be updated">
                <template v-slot:item="{ active, item, attrs, on }">
                  <v-list-item v-on="on" v-bind="attrs" #default="{ active }" three-line>
                    <v-list-item-action>
                    <v-checkbox :input-value="active"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-row no-gutters align="center">
                          <span>{{ item.name }}</span>
                          <v-spacer></v-spacer>
                          <v-chip text-color="white" small>{{ item.cost }}</v-chip>
                        </v-row>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <span>Discounted: {{ item.discounted }}</span>
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        <span>Cost: {{ item.cost }}</span>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
              <v-text-field label="Unit Price" prefix="KShs." type="number" step="0.01" min="0" v-model.number="dosage.cost" required="required" v-if="dosage.drug_id"></v-text-field>
              <v-text-field label="Quantity" type="number" step="0.01" v-model="dosage.quantity" required="required" min="0"></v-text-field>
              <p class="text-muted" v-if="dosage.drug_id">Total Price: {{ total_price }}</p>
              <v-textarea label="Dosage Instruction" :rows="2" auto-grow required="required" v-model="dosage.dosage"></v-textarea>
              <v-btn type="submit" small class="primary pull-right" :loading="dosage.processing">Add to treatment</v-btn><br>
            </form>
          </v-card-text>
        </v-card>
      </modal-dialog>
      <mk-dialog v-model="viewRequest" heading="Request Note">
        <v-card>
          <v-card-text v-if="request">
            <my-details header="Note">{{ request.note }}</my-details>
            <a download :href="'/' + request.file" v-show="request.file">Attached File</a>
          </v-card-text>
        </v-card>
      </mk-dialog>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const MkDialog = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/mk-dialog')
  const PrescriptionView = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "treatments" */ '@/Components/Treatments/treatment')
  const PrescriptionLock = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "treatments" */ '@/Components/Treatments/locking')
  const MyDetails = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/details')
  const ModalDialog = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/dialog')

  export default {
    name: 'ViewPrescription',
    layout,
    props: [
      'client', 'visit', 'treatment', 'drugs', 'pharmacy_request'
    ],
    components: {
      PrescriptionView,
      PrescriptionLock,
      ModalDialog,
      MyDetails,
      MkDialog,
    },
    metaInfo () {
      return {
        title: 'View Prescription',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        addDosage: false,
        dosage: this.$inertia.form({
          'drug_id': '',
          'quantity': 1,
          'dosage': '',
        }),
        viewRequest: false,
      }
    },
    methods: {
      saveDosage () {
        this.dosage.post('/treatments/' + this.treatment.id + '/drugs', {
          preserveScroll: true,
          onSuccess: (page) => {
            this.addDosage = false
            this.dosage.drug_id = ''
            this.dosage.quantity = 1
            this.dosage.dosage = ''
          }
        })
      },
      printPre () {
        window.print()
      },
      checkLock (e) {
        if (!this.treatment.locked) {
          e.preventDefault()
        }
      }
    },
    computed: {
      total_price () {
        let price = this.dosage.quantity * this.dosage.cost
        return price.format()
      },
      request () {
        if (!this.pharmacy_request) {
          return null
        }
        return this.pharmacy_request.request
      }
    },
    watch: {
      'dosage.drug_id': function (value) {
        if (value) {
          var drug = this.drugs.filter(function (dd) {
            return dd.id === value
          })
          this.dosage.cost = drug[0].cost
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  @media screen {
    .screen-mx-10 {
      margin-bottom: 10px;
    }
  }
</style>
